<template>
  <div>
    <b-card no-body class="cards card-box">
      <!--<div class="p-2">
        <b-button variant="primary" @click="abrirCadastrar">{{ $t("GERAL.NOVO") }}</b-button>
      </div>-->
      <div class="row">
        <filtro-empresas class="col-12 col-md-4" v-if="ehAdmin" @update="listar()" />
      </div>

      <tabela-padrao
        sem-selecionar-todos
        v-model="tabela.dados"
        :colunas="tabela.colunas"
        :quantidade-itens="tabela.quantidadeItens"
        ref="tabela"
        backend-paginado
        @paginar="listar"
        @doisClicksLinha="abrirEditar"
      >
        <template #cell(acoes)="linha">
          <div class="d-flex">
            <b-button
              variant="flat-primary"
              v-if="permissao.r"
              @click="abrirEditar(linha.item)"
            >
              <i class="fas fa-edit"></i>
            </b-button>
            <b-button variant="flat-danger" v-if="ehAdmin" @click="excluir(linha.item)">
              <i class="fas fa-trash"></i>
            </b-button>
          </div>
        </template>
      </tabela-padrao>
    </b-card>
  </div>
</template>

<script>
import Confirmacao from "@/components/confirmacao/Confirmacao";
import UsuarioService from "@/common/services/usuario/usuario.service";
import { DEFINIR_BREADCRUMB } from "@/store/breadcrumbs.module";
import { START_LOADING, STOP_LOADING } from "@/store/Store";
import Swal from "sweetalert2";

export default {
  name: "Usuarios",
  components: {},

  data() {
    return {
      tabela: {
        dados: [],
        colunas: [
          {
            key: "nomeUsuario",
            label: this.$t("USUARIOS.NOME"),
          },
          {
            key: "pessoa.telefone",
            label: this.$t("USUARIOS.TELEFONE"),
          },
          {
            key: "pessoa.email",
            label: this.$t("USUARIOS.EMAIL"),
          },
          /*{
          key: "acesso",
          label: this.$t("GERAL.ACESSO"),
        },*/
          {
            key: "acoes",
            label: this.$t("GERAL.ACOES"),
            tdClass: "acoes",
          },
        ],
        quantidadeItens: 0,
        paginaAtual: 0,
        porPagina: 0,
      },
    };
  },
  mounted() {
    this.$store.dispatch(DEFINIR_BREADCRUMB, [{ titulo: this.$t("MENU.USUARIOS") }]);
    this.listar();
    // this.listarEmpresas();
  },
  methods: {
    listar: function (paginaAtual = 0, porPagina = 10) {
      if (!this.empresaSelecionada) return;

      this.$store.dispatch(START_LOADING);
      UsuarioService.listar(this.empresaSelecionada, porPagina, paginaAtual)
        .then((res) => {
          this.tabela.dados = res.data.data.itens;
          this.paginaAtual = paginaAtual;
          this.porPagina = porPagina;
          this.tabela.quantidadeItens = res.data.data.paginacao.totalDeElementos;
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    abrirCadastrar() {
      this.$router.push({ name: "usuarios-formulario" });
    },
    abrirEditar(item) {
      if (this.permissao.r)
        this.$router.push({ name: "usuarios-formulario", params: { id: item.id } });
    },
    excluir(item) {
      Confirmacao.SimNao(
        this,
        null,
        this.$t("USUARIOS.CONFIRMAR_EXCLUIR").formatUnicorn({
          nome: item.nome,
        })
      ).then(async (result) => {
        if (result.value) {
          this.$store.dispatch(START_LOADING);
          UsuarioService.excluir(item.id)
            .then(() => {
              Swal.fire({
                title: this.$t("GERAL.SUCCESSO"),
                text: this.$t("USUARIOS.MENSAGEM_EXCLUIDO"),
                icon: "success",
                confirmButtonText: this.$t("GERAL.OK"),
              }).then((result) => {
                if (result.isConfirmed) {
                  this.listar();
                }
              });
            })
            .catch((err) => {
              Swal.fire({
                title: this.$t("GERAL.ERRO"),
                text: err.response.data.errors,
                icon: "error",
              });
            })
            .finally(() => {
              this.$store.dispatch(STOP_LOADING);
            });
        }
      });
    },
  },
  computed: {
    permissao() {
      return this.$store.getters["app/retornaPermissao"]("Usuarios");
    },
    ehAdmin() {
      return this.$store.getters["app/ehAdmin"];
    },
    empresaSelecionada() {
      return this.$store.state.app.selectedCompanyObj?.id;
    },
  },
};
</script>
